import React from "react";
import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

function TournamentMetricCards({ dashboardStats, loading }) {
  const approved = dashboardStats?.paid_approved_count ?? 0;
  const items = [
    {
      key: "total",
      label: "Total Tournaments",
      value: dashboardStats?.total_tournaments ?? 0,
      tone: "slate",
    },
    {
      key: "upcoming",
      label: "Upcoming Tournaments",
      value: dashboardStats?.upcoming_tournaments ?? 0,
      tone: "mint",
    },
    {
      key: "ongoing",
      label: "Ongoing Tournaments",
      value: dashboardStats?.ongoing_tournaments ?? 0,
      tone: "teal",
    },
    {
      key: "completed",
      label: "Completed Tournaments",
      value: dashboardStats?.completed_tournaments ?? 0,
      tone: "coral",
    },
    {
      key: "participants",
      label: "Total Participants",
      value: dashboardStats?.total_participants ?? 0,
      tone: "slate",
    },
    {
      key: "revenue",
      label: "Tournament Revenue",
      value: `₹${approved}`,
      tone: "teal",
    },
  ];

  return (
    <GlobalMetricCards
      items={items}
      loading={loading}
      skeletonCount={6}
      ariaLabel="Tournament dashboard statistics"
    />
  );
}

export default function TournamentDashboardMetricsSection({ dashboardStats, loadingStats }) {
  return (
    <div id="td-stats" className="user-builder-panel" style={{ scrollMarginTop: "2rem" }}>
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Performance overview</h3>
        <p className="user-builder-panel__hint">
          Tournament counts, participant registrations linked to students, and revenue from payments that are both
          recorded as paid and verified (approved).
        </p>
      </div>
      <TournamentMetricCards dashboardStats={dashboardStats} loading={loadingStats} />
    </div>
  );
}
